import React from "react";

interface IProps {
  children: React.ReactNode;
  title?: string;
  maxWidth?: string;
}

export const PageContent: React.FC<IProps> = ({
  children = null,
  title = "",
  maxWidth = "max-w-7xl",
}) => {
  return (
    <div className={`w-full ${maxWidth} mx-auto p-6`}>
      {title && (
        <div className="text-2xl py-6 w-full text-center lg:text-left z-10">
          {title}
        </div>
      )}
      <>{children}</>
    </div>
  );
};
